import { del, get, post, put } from '@api/request';

export const fetchTaxingUnits = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnit = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID },
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitTypes = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/taxingunit/type`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitFundTypes = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/taxingunit/fundtype`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitEPTSTypes = async (
  { assessmentService },
  authenticationToken,
) => {
  const url = `${assessmentService}/assessment/taxingunit/eptsform`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createTaxingUnit = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const url = `${assessmentService}/assessment/taxingunits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateTaxingUnit = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const { taxingUnitID } = payload;
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteTaxingUnit = async (
  { assessmentService },
  authenticationToken,
  { payload: { taxingUnitID } },
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitRevisionHistory = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID }
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/revisionhistory`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitVersionRevisionHistory = async (
  { assessmentService },
  authenticationToken,
  { versionID }
) => {
  const url = `${assessmentService}/assessment/taxingunit/${versionID}/version/revisionhistory`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTaxingUnitNotes = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID }
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/notes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createTaxingUnitNote = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID, payload }
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/notes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateTaxingUnitNote = async (
  { assessmentService },
  authenticationToken,
  { noteID, payload }
) => {
  const url = `${assessmentService}/assessment/taxingunit/note/${noteID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteTaxingUnitNote = async (
  { assessmentService },
  authenticationToken,
  { noteID }
) => {
  const url = `${assessmentService}/assessment/taxingunit/note/${noteID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchSingleTaxingUnitNote = async (
  { assessmentService },
  authenticationToken,
  { noteID }
) => {
  const url = `${assessmentService}/assessment/taxingunit/note/${noteID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};